import { z } from "zod";
import { phoneRegex } from "../validationRegex";
export const getPhoneSchema = (t, opts) => {
    const { phoneNumberRequired } = opts;
    const base = z
        .string({ invalid_type_error: t("contact.form.phone_error_invalid") })
        .trim()
        .regex(phoneRegex, { message: t("contact.form.phone_error_invalid") });
    if (phoneNumberRequired) {
        return z.object({
            phoneNumber: base.min(1, {
                message: t("contact.form.phone_error_empty"),
            }),
        });
    }
    return z.object({
        phoneNumber: base
            .min(2, { message: t("contact.form.phone_error_invalid") })
            .optional()
            .nullable()
            .or(z.literal("")),
    });
};
